import FieldsValidation from '@components/Form/validationform/FieldsValidation';
import { TypesValidation } from '@src/helpers/Enums';
import styled from '@src/styled-components';
import { Form, Tree } from 'antd';
import FormItem from 'antd/lib/form/FormItem';
import React from 'react';

const { TreeNode } = Tree;

export interface ITreeViewExecutionProps {
  description: string;
  treeView: any;
  onChange: Function;
  id: number,
  required: Boolean
}

interface ITreeViewExecutionState {
  selectComponent: any;
  validation: boolean[];
  isChecked: boolean;
}
export default class TreeViewExecutionComponent extends React.Component<ITreeViewExecutionProps, ITreeViewExecutionState> {
  constructor(props: ITreeViewExecutionProps) {
    super(props);
    this.state = {
      selectComponent: [false],
      // validation: [false],
      isChecked: false
    }
  }
  //#region  START HANDLES 
  handleSelectChange = (idx: any) => async (evt: any) => {
    // const newInputSelect = [{ value: evt[0] ? true : false }]
    // this.setState({ selectComponent: newInputSelect });
    this.props.onChange({
      id: this.props.id,
      value: evt[0] ? true : false,
      validation: !evt[0] && this.props.required ? false : true
    })
  }

  // handleAddSelect = async () => {
  //   this.setState({ selectComponent: this.state.selectComponent.concat([{ value: '' }]) })
  // }

  // handleRemoveSelect = (index: number) => async () => {
  //   this.setState({
  //     selectComponent: this.state.selectComponent.filter((section: any, sindex: number) => index !== sindex),
  //   });
  // }
  //#endregion

  // validationFunction = (selectComponent : any) => {
  //   for (let optionsItems of selectComponent) {
  //     if (optionsItems.value === false) {
  //       return true
  //     }
  //     else if (optionsItems.value === true) {
  //       return false
  //     }
  //   }
  // }

  getOptionsTreeView() {
    let treeNode: JSX.Element[] = []
    const parent = this.props.treeView.find((e: any) => e.depth === 0)
    const child1 = this.props.treeView.find((e: any) => e.depth === 1)
    const child2 = this.props.treeView.find((e: any) => e.depth === 2)
    treeNode.push(
      <TreeNode title={parent.value} key={parent.depth}>
        {child1 &&<TreeNode title={child1.value} key={child1.depth}>
          {child2 && <TreeNode title={child2.value} key={child2.depth}>
          </TreeNode>}
        </TreeNode>}
      </TreeNode>
    )
    return treeNode;
  }

  render() {
    return (
      <Wrapper>
        <Form>
          <p>{this.props.description}</p>
          <FormItem>
            <FieldsValidation
              type={TypesValidation.TREEVIEW}
              treeNodeOptions={this.getOptionsTreeView()}
              handleOnChange={this.handleSelectChange()}
            />
          </FormItem>
        </Form>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  .button-style{
    margin-right: 20px;
    margin-bottom: 8px;
  }
`